import { DeviceConnectionStatus } from '@/features/devices/types/types'
import WifiIcon from '@/shared/assets/icons/wifiicon.svg?react'
import { BatteryIcon } from '../icons/BatteryIcon'
import clsx from 'clsx'

type Props = {
  direction: 'row' | 'col'
  battery: number | null
  network: number | null
  status: DeviceConnectionStatus
}

export const DeviceState = ({ battery, network, direction, status }: Props) => {
  const containerClass = clsx(
    'flex',
    {
      'flex-row gap-2': direction === 'row',
      'flex-col gap-0': direction === 'col',
    },
    'text-sm whitespace-nowrap'
  )

  const connectionClass = clsx(
    'pl-[10px]',
    'font-klein font-medium',
    'before:absolute before:w-[5px] before:h-[5px] before:rounded-full before:left-0 before:top-[50%] before:transform before:-translate-y-[50%]',
    status === DeviceConnectionStatus.Online
      ? 'text-success before:bg-success'
      : 'text-text-secondary before:bg-text-secondary'
  )

  const wifiClass = clsx(
    'font-klein font-medium',
    network == null
      ? 'text-text-secondary'
      : network === 0
        ? 'text-error'
        : network < 30
          ? 'text-warning'
          : 'text-success'
  )

  return (
    <div className={containerClass}>
      <div className="relative">
        <span className={connectionClass}>
          {status === DeviceConnectionStatus.Online ? 'Онлайн' : 'Оффлайн'}
        </span>
      </div>
      <div className="flex gap-2">
        <div className="flex items-center gap-1">
          <BatteryIcon battery={battery} />
          <span className="font-klein font-medium text-text-secondary">
            {battery !== null ? `${battery}%` : 'Нет данных'}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <WifiIcon className={wifiClass} />
          <span className={wifiClass}>
            {network !== null ? `${Math.floor(network)} Мб/с` : 'Нет данных'}
          </span>
        </div>
      </div>
    </div>
  )
}
